/**
 * Generate Study Dialog - Step 4: Select Environment
 *
 * Migrated from: lego/page/etmf/overview/generate-study/Step4.jsx
 */

import React from 'react'
import { FormikProps } from 'formik'
import { useDialogContext } from './context/useDialogContext'
import { useServiceContext } from '../../../../root'
import { Select } from '../../../../components/Select/Select'
import type { FormValues, SelectOption } from './context/DialogContext'
import type { OptionType } from '../../../../components/Select/Select'

interface Step4Props extends Partial<FormikProps<FormValues>> {}

export function Step4({ values, setFieldValue, errors }: Step4Props) {
  const dialogData = useDialogContext()
  const context = useServiceContext()
  const { translate } = context.service.filter

  // Transform SelectOption to OptionType format for the Select component
  const options: OptionType[] = dialogData.environmentOptions.map((opt) => ({
    value: opt.value,
    label: opt.label
  }))

  return (
    <div className="step step4">
      <div className="form-group w50p">
        <div className="mcc-form-group">
          <label htmlFor="environment-select" className="has-step-circle control-label mb10">
            <span className="step-circle">3</span>
            <span>{translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP_ENVIRONMENTS')}</span>
          </label>
        </div>
        <Select
          id="environment-select"
          name="environment"
          value={values?.environment}
          options={options}
          placeholder={translate('SELECT_ENVIRONMENT')}
          isClearable={false}
          isSearchable={true}
          onChange={(option) => {
            setFieldValue?.('environment', option ? (option as OptionType).value : null)
          }}
        />
        {errors?.environment && <div className="text-danger fs14">{errors.environment}</div>}
      </div>
    </div>
  )
}

export default Step4
